import { AxiosResponse } from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'libs/Axios';
import { AxiosDefaultErrorEntity } from 'types/api/Common/ErrorTypes';
import {
  DruidSyncTenant,
  DruidSyncRunRequest,
  DruidSyncRunResponse,
} from 'types/api/TenantMaster/DruidSyncTypes';

export const DRUID_SYNC_QUERY_KEY = {
  TENANT_LIST: 'DRUID_SYNC_TENANT_LIST',
};

export function useDruidSyncTenantList() {
  return useQuery<AxiosResponse<DruidSyncTenant[]>, AxiosDefaultErrorEntity>(
    [DRUID_SYNC_QUERY_KEY.TENANT_LIST],
    () => axios.get('/api/v1/master/druid-sync/tenant-list').then((res) => res),
  );
}

export function useTriggerDruidSync() {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<DruidSyncRunResponse>, AxiosDefaultErrorEntity, DruidSyncRunRequest>(
    (bodyRequest) => axios.post('/api/v1/master/druid-sync/runs', bodyRequest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(DRUID_SYNC_QUERY_KEY.TENANT_LIST);
      },
    },
  );
}
